import { InspectorControls, useBlockProps } from "@wordpress/block-editor";

import AllInspectorSettings from "./InspectorControls";
import FormInputStylesControls, { getInputStyleVars } from '../../../components/FormInputStylesControls';

import "../style.scss";

export default function Edit(props) {
  return (
    <>
      <InspectorControls>
        <AllInspectorSettings {...props} />
        <FormInputStylesControls {...props} />
      </InspectorControls>
      <Content {...props} />
    </>
  );
}

export function Content({ attributes, isSave = false }) {
  const { name, isRequired, label, autocomplete, id, validate } = attributes;

  const blockProps = isSave ? useBlockProps.save() : useBlockProps();
  const inputVars = getInputStyleVars(attributes.style && attributes.style.inputStyles);
  return (
    <div {...blockProps} style={{ ...blockProps.style, ...inputVars }}>
      {label && (
        <label className="wp-block-brandy-form-label" htmlFor={id}>
          {label}
          {isRequired && (
            <abbr class="required" title="required">
              *
            </abbr>
          )}
        </label>
      )}
      <input
        className="wp-block-brandy-form-field"
        type="text"
        id={id}
        name={name}
        autocomplete={autocomplete ? "on" : "off"}
        required={isRequired}
        pattern={
          validate
            ? "/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/"
            : ""
        }
      />
    </div>
  );
}
